var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3AxTandem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1894.64 800.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fbb040;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-80,.cls-81,.cls-82,.cls-83,.cls-84,.cls-85,.cls-86,.cls-87,.cls-88,.cls-89,.cls-90,.cls-91,.cls-92,.cls-93,.cls-94,.cls-95,.cls-96,.cls-97,.cls-98,.cls-99,.cls-100,.cls-101,.cls-102,.cls-103,.cls-104,.cls-105,.cls-106,.cls-107,.cls-108,.cls-109,.cls-110,.cls-111,.cls-112,.cls-113,.cls-114,.cls-115,.cls-116,.cls-117,.cls-118,.cls-119,.cls-120,.cls-121,.cls-122,.cls-123,.cls-124,.cls-125,.cls-126,.cls-127,.cls-128,.cls-129,.cls-130,.cls-131,.cls-132,.cls-133,.cls-134,.cls-135,.cls-136,.cls-137,.cls-138,.cls-139,.cls-140,.cls-141,.cls-142,.cls-143,.cls-144,.cls-145,.cls-146,.cls-147,.cls-148,.cls-149,.cls-150,.cls-151,.cls-152,.cls-153,.cls-154,.cls-155,.cls-156,.cls-157,.cls-158,.cls-159{stroke-width:0px;}.cls-2,.cls-156{fill:#414042;}.cls-3,.cls-33,.cls-160,.cls-136,.cls-137,.cls-138,.cls-140,.cls-150,.cls-151,.cls-152,.cls-153,.cls-156,.cls-158{mix-blend-mode:multiply;}.cls-3,.cls-129{fill:#f1f2f2;}.cls-4{fill:url(#New_Gradient_Swatch_4);}.cls-5{fill:url(#New_Gradient_Swatch_3);}.cls-6{fill:url(#New_Gradient_Swatch_3-3);}.cls-7{fill:url(#New_Gradient_Swatch_3-2);}.cls-8{fill:url(#New_Gradient_Swatch_4-3);}.cls-9{fill:url(#New_Gradient_Swatch_4-2);}.cls-10{fill:#f7941d;}.cls-11{fill:url(#linear-gradient-120);}.cls-12{fill:url(#linear-gradient-124);}.cls-13{fill:url(#linear-gradient-100);}.cls-14{fill:url(#linear-gradient-123);}.cls-15{fill:url(#linear-gradient-121);}.cls-16{fill:url(#linear-gradient-122);}.cls-17{fill:url(#linear-gradient-109);}.cls-18{fill:url(#linear-gradient-108);}.cls-19{fill:url(#linear-gradient-106);}.cls-20{fill:url(#linear-gradient-107);}.cls-21{fill:url(#linear-gradient-104);}.cls-22{fill:url(#linear-gradient-103);}.cls-23{fill:url(#linear-gradient-105);}.cls-24{fill:url(#linear-gradient-117);}.cls-25{fill:url(#linear-gradient-111);}.cls-26{fill:url(#linear-gradient-112);}.cls-27{fill:url(#linear-gradient-110);}.cls-28{fill:url(#linear-gradient-113);}.cls-29{fill:url(#linear-gradient-114);}.cls-30{fill:url(#linear-gradient-115);}.cls-31{fill:url(#linear-gradient-116);}.cls-32{fill:url(#linear-gradient-119);}.cls-161{mask:url(#mask);}.cls-33{fill:#fff;}.cls-34,.cls-137{fill:#ed1c24;}.cls-35{fill:url(#linear-gradient);}.cls-162{filter:url(#luminosity-noclip);}.cls-36{fill:#ef4136;}.cls-37,.cls-136{fill:#6d6e71;}.cls-38{fill:#f15a29;}.cls-39{fill:url(#linear-gradient-38);}.cls-40{fill:url(#linear-gradient-33);}.cls-41{fill:url(#linear-gradient-29);}.cls-42{fill:url(#linear-gradient-32);}.cls-43{fill:url(#linear-gradient-30);}.cls-44{fill:url(#linear-gradient-31);}.cls-45{fill:url(#linear-gradient-36);}.cls-46{fill:url(#linear-gradient-39);}.cls-47{fill:url(#linear-gradient-34);}.cls-48{fill:url(#linear-gradient-37);}.cls-49{fill:url(#linear-gradient-35);}.cls-50{fill:url(#linear-gradient-28);}.cls-51{fill:url(#linear-gradient-25);}.cls-52{fill:url(#linear-gradient-11);}.cls-53{fill:url(#linear-gradient-12);}.cls-54{fill:url(#linear-gradient-13);}.cls-55{fill:url(#linear-gradient-10);}.cls-56{fill:url(#linear-gradient-17);}.cls-57{fill:url(#linear-gradient-16);}.cls-58{fill:url(#linear-gradient-19);}.cls-59{fill:url(#linear-gradient-15);}.cls-60{fill:url(#linear-gradient-23);}.cls-61{fill:url(#linear-gradient-21);}.cls-62{fill:url(#linear-gradient-18);}.cls-63{fill:url(#linear-gradient-14);}.cls-64{fill:url(#linear-gradient-22);}.cls-65{fill:url(#linear-gradient-20);}.cls-66{fill:url(#linear-gradient-27);}.cls-67{fill:url(#linear-gradient-24);}.cls-68{fill:url(#linear-gradient-26);}.cls-69{fill:url(#linear-gradient-45);}.cls-70{fill:url(#linear-gradient-46);}.cls-71{fill:url(#linear-gradient-44);}.cls-72{fill:url(#linear-gradient-48);}.cls-73{fill:url(#linear-gradient-49);}.cls-74{fill:url(#linear-gradient-47);}.cls-75{fill:url(#linear-gradient-42);}.cls-76{fill:url(#linear-gradient-43);}.cls-77{fill:url(#linear-gradient-40);}.cls-78{fill:url(#linear-gradient-41);}.cls-79{fill:url(#linear-gradient-59);}.cls-80{fill:url(#linear-gradient-57);}.cls-81{fill:url(#linear-gradient-58);}.cls-82{fill:url(#linear-gradient-55);}.cls-83{fill:url(#linear-gradient-56);}.cls-84{fill:url(#linear-gradient-53);}.cls-85{fill:url(#linear-gradient-51);}.cls-86{fill:url(#linear-gradient-52);}.cls-87{fill:url(#linear-gradient-50);}.cls-88{fill:url(#linear-gradient-54);}.cls-89{fill:url(#linear-gradient-60);}.cls-90{fill:url(#linear-gradient-61);}.cls-91{fill:url(#linear-gradient-62);}.cls-92{fill:url(#linear-gradient-65);}.cls-93{fill:url(#linear-gradient-79);}.cls-94{fill:url(#linear-gradient-78);}.cls-95{fill:url(#linear-gradient-77);}.cls-96{fill:url(#linear-gradient-75);}.cls-97{fill:url(#linear-gradient-76);}.cls-98{fill:url(#linear-gradient-74);}.cls-99{fill:url(#linear-gradient-67);}.cls-100{fill:url(#linear-gradient-68);}.cls-101{fill:url(#linear-gradient-66);}.cls-102{fill:url(#linear-gradient-63);}.cls-103{fill:url(#linear-gradient-69);}.cls-104{fill:url(#linear-gradient-64);}.cls-105{fill:url(#linear-gradient-71);}.cls-106{fill:url(#linear-gradient-72);}.cls-107{fill:url(#linear-gradient-70);}.cls-108{fill:url(#linear-gradient-73);}.cls-109{fill:url(#linear-gradient-84);}.cls-110{fill:url(#linear-gradient-85);}.cls-111{fill:url(#linear-gradient-82);}.cls-112{fill:url(#linear-gradient-83);}.cls-113{fill:url(#linear-gradient-89);}.cls-114{fill:url(#linear-gradient-88);}.cls-115{fill:url(#linear-gradient-86);}.cls-116{fill:url(#linear-gradient-87);}.cls-117{fill:url(#linear-gradient-80);}.cls-118{fill:url(#linear-gradient-81);}.cls-119{fill:url(#linear-gradient-98);}.cls-120{fill:url(#linear-gradient-91);}.cls-121{fill:url(#linear-gradient-92);}.cls-122{fill:url(#linear-gradient-93);}.cls-123{fill:url(#linear-gradient-90);}.cls-124{fill:url(#linear-gradient-96);}.cls-125{fill:url(#linear-gradient-97);}.cls-126{fill:url(#linear-gradient-94);}.cls-127{fill:url(#linear-gradient-95);}.cls-128{fill:url(#linear-gradient-99);}.cls-130{fill:#58595b;}.cls-131,.cls-138{fill:#bcbec0;}.cls-132{fill:#808285;}.cls-133,.cls-141{fill:#000;}.cls-134,.cls-140{fill:#a7a9ac;}.cls-135{fill:url(#New_Gradient_Swatch_11_cop);}.cls-139{fill:#be1e2d;}.cls-141{opacity:.5;}.cls-142{fill:url(#linear-gradient-4);}.cls-143{fill:url(#linear-gradient-2);}.cls-144{fill:url(#linear-gradient-3);}.cls-145{fill:url(#linear-gradient-8);}.cls-146{fill:url(#linear-gradient-9);}.cls-147{fill:url(#linear-gradient-7);}.cls-148{fill:url(#linear-gradient-5);}.cls-149{fill:url(#linear-gradient-6);}.cls-150{fill:url(#linear-gradient-101);}.cls-151{fill:url(#linear-gradient-102);}.cls-152{fill:url(#linear-gradient-118);}.cls-153,.cls-155{fill:#c49a6c;}.cls-163{isolation:isolate;}.cls-154{fill:#e6e7e8;}.cls-157{fill:#d1d3d4;}.cls-158{fill:#939598;}.cls-159{fill:#231f20;}"), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 0,
    y: 712.8,
    width: 1694.64,
    height: 87.31,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 712.8,
    width: 1694.64,
    height: 87.31,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-162"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1696,
    height: 88,
    transform: "translate(-.43 712.2)",
    xlinkHref: "data:image/png;base64,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"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1647,
    y1: 577.92,
    x2: 1651.01,
    y2: 577.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#6c6e70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#96989b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -15768.39,
    y1: 5120.21,
    x2: -15768.39,
    y2: 5104.76,
    gradientTransform: "translate(17418.65 -4516.65)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#434345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#4d4c4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#5c5d5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#737376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#8f9194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1650.38,
    y1: 551.26,
    x2: 1670.95,
    y2: 551.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#464547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#707072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#939495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#aeafb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#c1c3c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#cdcfd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1648.22,
    y1: 597.44,
    x2: 1648.22,
    y2: 594.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#939598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    y1: 594.07,
    y2: 590.75,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1648.98,
    y1: 567.03,
    x2: 1648.98,
    y2: 542.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    y1: 592.1,
    y2: 587.77,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1613.68,
    y1: 577.1,
    x2: 1658.71,
    y2: 577.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1663.2,
    y1: 579.8,
    x2: 1683.75,
    y2: 579.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#67686a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#9d9e9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#c4c5c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#dddedf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4",
    x1: 262.38,
    y1: 713.67,
    x2: 262.38,
    y2: 526.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3",
    x1: 262.38,
    y1: 543.79,
    x2: 262.38,
    y2: 702.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58595b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 262.38,
    y1: 570.62,
    x2: 262.38,
    y2: 670.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 262.38,
    y1: 650.34,
    x2: 262.38,
    y2: 590.15,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 262.38,
    y1: 678.45,
    x2: 262.38,
    y2: 563.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 262.38,
    y1: 604.09,
    x2: 262.38,
    y2: 638.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 262.38,
    y1: 634.15,
    x2: 262.38,
    y2: 607.3,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1148.17,
    y1: 546.43,
    x2: 1148.17,
    y2: 552.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1148.17,
    y1: 552.3,
    x2: 1148.17,
    y2: 558,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    y1: 558.16,
    y2: 563.61,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1148.17,
    y1: 563.92,
    x2: 1148.17,
    y2: 569.25,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    y1: 569.35,
    y2: 575.12,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1148.17,
    y1: 575.33,
    x2: 1148.17,
    y2: 581.32,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    y1: 581.63,
    y2: 586.63,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 1148.17,
    y1: 586.85,
    x2: 1148.17,
    y2: 592.06,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 1148.17,
    y1: 593.04,
    x2: 1148.17,
    y2: 598.15,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 1148.17,
    y1: 598.91,
    x2: 1148.17,
    y2: 604.02,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 1148.17,
    y1: 604.56,
    x2: 1148.17,
    y2: 610.45,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    y1: 610.86,
    y2: 615.75,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 1128.23,
    y1: 546.38,
    x2: 1128.23,
    y2: 622.59,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1168.1,
    y1: 546.38,
    x2: 1168.1,
    y2: 622.59,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-2",
    x1: 1029.67,
    x2: 1029.67,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-2",
    x1: 1029.67,
    x2: 1029.67,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 1029.67,
    x2: 1029.67,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 1029.64,
    y1: 569.83,
    x2: 1029.64,
    y2: 670.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#68696b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#929495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 1029.67,
    y1: 638.92,
    x2: 1029.67,
    y2: 601.67,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 1029.67,
    y1: 634.04,
    x2: 1029.67,
    y2: 607.41,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-3",
    x1: 1266.37,
    x2: 1266.37,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-3",
    x1: 1266.37,
    x2: 1266.37,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 1266.37,
    x2: 1266.37,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 1266.33,
    x2: 1266.33,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 1266.37,
    y1: 638.92,
    x2: 1266.37,
    y2: 601.67,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 1266.37,
    y1: 634.04,
    x2: 1266.37,
    y2: 607.41,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 2103.76,
    y1: 13609.15,
    x2: 2103.76,
    y2: 13430.47,
    gradientTransform: "translate(-12024.77 2708.65) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#262224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#525254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#515254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#403f41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#252122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 2125.25,
    y1: 13427.47,
    x2: 2125.25,
    y2: 13611.96,
    gradientTransform: "translate(3711.8 14194.74) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#2b2729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3b393b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#3a393b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#2a2728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    y1: 13427.49,
    y2: 13611.96,
    gradientTransform: "translate(3709.23 14192.16) rotate(-180)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    y1: 13427.49,
    y2: 13611.96,
    gradientTransform: "translate(3706.05 14188.98) rotate(-180)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    y1: 13427.49,
    y2: 13611.96,
    gradientTransform: "translate(3702.22 14185.15) rotate(-180)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    y1: 13427.49,
    y2: 13611.96,
    gradientTransform: "translate(3697.72 14180.65) rotate(-180)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    y1: 13427.48,
    y2: 13611.96,
    gradientTransform: "translate(3692.68 14175.61) rotate(-180)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    y1: 13427.49,
    y2: 13611.95,
    gradientTransform: "translate(3687.1 14170.03) rotate(-180)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    y1: 13427.48,
    y2: 13611.96,
    gradientTransform: "translate(3681.05 14163.98) rotate(-180)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    y1: 13427.48,
    y2: 13611.95,
    gradientTransform: "translate(3674.38 14157.31) rotate(-180)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    y1: 13427.49,
    y2: 13611.95,
    gradientTransform: "translate(3667.45 14150.38) rotate(-180)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    y1: 13427.48,
    y2: 13611.96,
    gradientTransform: "translate(3660.01 14142.95) rotate(-180)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    y1: 13427.48,
    y2: 13611.96,
    gradientTransform: "translate(3652.36 14135.29) rotate(-180)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    y1: 13427.48,
    y2: 13611.96,
    gradientTransform: "translate(3644.34 14127.28) rotate(-180)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    y1: 13427.49,
    y2: 13611.95,
    gradientTransform: "translate(3636.23 14119.16) rotate(-180)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    y1: 13427.49,
    y2: 13611.95,
    gradientTransform: "translate(3628 14110.94) rotate(-180)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    y1: 13427.48,
    y2: 13611.95,
    gradientTransform: "translate(-721.97 -12844.64)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    y1: 13427.48,
    y2: 13611.95,
    gradientTransform: "translate(-719.4 -12847.21)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    y1: 13427.48,
    y2: 13611.95,
    gradientTransform: "translate(-716.22 -12850.39)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    y1: 13427.48,
    y2: 13611.96,
    gradientTransform: "translate(-712.39 -12854.22)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    y1: 13427.49,
    y2: 13611.95,
    gradientTransform: "translate(-707.89 -12858.72)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    y1: 13427.48,
    y2: 13611.96,
    gradientTransform: "translate(-702.85 -12863.76)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    y1: 13427.48,
    y2: 13611.96,
    gradientTransform: "translate(-697.26 -12869.35)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    y1: 13427.48,
    y2: 13611.96,
    gradientTransform: "translate(-691.21 -12875.4)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    y1: 13427.48,
    y2: 13611.95,
    gradientTransform: "translate(-684.54 -12882.07)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    y1: 13427.49,
    y2: 13611.95,
    gradientTransform: "translate(-677.61 -12889)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    y1: 13427.48,
    y2: 13611.96,
    gradientTransform: "translate(-670.18 -12896.43)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    y1: 13427.48,
    y2: 13611.96,
    gradientTransform: "translate(-662.53 -12904.08)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    y1: 13427.49,
    y2: 13611.95,
    gradientTransform: "translate(-654.51 -12912.1)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    y1: 13427.49,
    y2: 13611.95,
    gradientTransform: "translate(-646.39 -12920.21)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    y1: 13427.48,
    y2: 13611.95,
    gradientTransform: "translate(-638.17 -12928.44)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 2125.25,
    y1: 13427.49,
    x2: 2125.25,
    y2: 13611.95,
    gradientTransform: "translate(-630.33 -12936.28)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 2082.28,
    x2: 2082.28,
    gradientTransform: "translate(3668.84 14237.71) rotate(-180)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 2082.28,
    y1: 13427.49,
    x2: 2082.28,
    y2: 13611.96,
    gradientTransform: "translate(3666.26 14235.13) rotate(-180)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 2082.28,
    y1: 13427.49,
    x2: 2082.28,
    y2: 13611.96,
    gradientTransform: "translate(3663.08 14231.95) rotate(-180)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 2082.28,
    y1: 13427.49,
    x2: 2082.28,
    y2: 13611.96,
    gradientTransform: "translate(3659.25 14228.12) rotate(-180)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 2082.28,
    y1: 13427.49,
    x2: 2082.28,
    y2: 13611.96,
    gradientTransform: "translate(3654.75 14223.62) rotate(-180)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 2082.28,
    y1: 13427.48,
    x2: 2082.28,
    y2: 13611.96,
    gradientTransform: "translate(3649.71 14218.58) rotate(-180)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 2082.28,
    y1: 13427.49,
    x2: 2082.28,
    y2: 13611.95,
    gradientTransform: "translate(3644.13 14213) rotate(-180)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 2082.28,
    y1: 13427.48,
    x2: 2082.28,
    y2: 13611.96,
    gradientTransform: "translate(3638.08 14206.95) rotate(-180)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 2082.28,
    y1: 13427.48,
    x2: 2082.28,
    y2: 13611.95,
    gradientTransform: "translate(3631.41 14200.28) rotate(-180)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 2082.28,
    y1: 13427.49,
    x2: 2082.28,
    y2: 13611.95,
    gradientTransform: "translate(3624.48 14193.35) rotate(-180)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 2082.28,
    y1: 13427.48,
    x2: 2082.28,
    y2: 13611.96,
    gradientTransform: "translate(3617.04 14185.91) rotate(-180)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 2082.28,
    y1: 13427.48,
    x2: 2082.28,
    y2: 13611.96,
    gradientTransform: "translate(3609.39 14178.26) rotate(-180)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 2082.28,
    y1: 13427.48,
    x2: 2082.28,
    y2: 13611.96,
    gradientTransform: "translate(3601.38 14170.25) rotate(-180)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 2082.28,
    y1: 13427.49,
    x2: 2082.28,
    y2: 13611.95,
    gradientTransform: "translate(3593.26 14162.13) rotate(-180)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 2082.28,
    y1: 13427.49,
    x2: 2082.28,
    y2: 13611.95,
    gradientTransform: "translate(3585.04 14153.91) rotate(-180)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 2082.28,
    y1: 13427.48,
    x2: 2082.28,
    y2: 13611.95,
    gradientTransform: "translate(-679 -12801.67)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 2082.28,
    y1: 13427.48,
    x2: 2082.28,
    y2: 13611.95,
    gradientTransform: "translate(-676.43 -12804.25)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 2082.28,
    y1: 13427.48,
    x2: 2082.28,
    y2: 13611.95,
    gradientTransform: "translate(-673.25 -12807.43)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 2082.28,
    y1: 13427.48,
    x2: 2082.28,
    y2: 13611.96,
    gradientTransform: "translate(-669.42 -12811.25)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 2082.28,
    y1: 13427.49,
    x2: 2082.28,
    y2: 13611.95,
    gradientTransform: "translate(-664.92 -12815.75)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 2082.28,
    y1: 13427.48,
    x2: 2082.28,
    y2: 13611.96,
    gradientTransform: "translate(-659.88 -12820.79)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 2082.28,
    y1: 13427.48,
    x2: 2082.28,
    y2: 13611.96,
    gradientTransform: "translate(-654.3 -12826.38)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 2082.28,
    y1: 13427.48,
    x2: 2082.28,
    y2: 13611.96,
    gradientTransform: "translate(-648.25 -12832.43)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 2082.28,
    y1: 13427.48,
    x2: 2082.28,
    y2: 13611.95,
    gradientTransform: "translate(-641.58 -12839.1)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 2082.28,
    y1: 13427.49,
    x2: 2082.28,
    y2: 13611.95,
    gradientTransform: "translate(-634.65 -12846.03)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 2082.28,
    y1: 13427.48,
    x2: 2082.28,
    y2: 13611.96,
    gradientTransform: "translate(-627.21 -12853.46)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 2082.28,
    y1: 13427.48,
    x2: 2082.28,
    y2: 13611.96,
    gradientTransform: "translate(-619.56 -12861.11)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 2082.28,
    y1: 13427.49,
    x2: 2082.28,
    y2: 13611.95,
    gradientTransform: "translate(-611.55 -12869.13)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 2082.28,
    y1: 13427.49,
    x2: 2082.28,
    y2: 13611.95,
    gradientTransform: "translate(-603.43 -12877.25)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 2082.28,
    y1: 13427.48,
    x2: 2082.28,
    y2: 13611.95,
    gradientTransform: "translate(-595.2 -12885.47)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 2082.28,
    y1: 13427.49,
    x2: 2082.28,
    y2: 13611.95,
    gradientTransform: "translate(-587.36 -12893.31)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 2103.76,
    y1: 13428.98,
    x2: 2103.76,
    y2: 13612.45,
    gradientTransform: "translate(-608.85 -12914.79)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 157.57,
    y1: 396.46,
    x2: 157.57,
    y2: 255.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 304.78,
    y1: 396.46,
    x2: 304.78,
    y2: 255.65,
    xlinkHref: "#linear-gradient-101"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 415.35,
    y1: 565.29,
    x2: 415.35,
    y2: 483.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c2415"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: -10344.88,
    y1: 11723.2,
    x2: -10344.88,
    y2: 11641.63,
    gradientTransform: "translate(-9913.24 12232.44) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#020000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#0c0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#1b0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#320000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#4e0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e0001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: -10485.07,
    y1: 11776.16,
    x2: -10485.07,
    y2: 11844,
    gradientTransform: "translate(-14244.39 6367.77) rotate(-153.27)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: -10485.07,
    y1: 11836.21,
    x2: -10485.07,
    y2: 11783.14,
    gradientTransform: "translate(-14336.37 6130.79) rotate(-152.35)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: -10485.07,
    y1: 11788.89,
    x2: -10485.07,
    y2: 11830.87,
    gradientTransform: "translate(-12515.51 -8507.43) rotate(-96.67)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: -10485.07,
    y1: 11826.05,
    x2: -10485.07,
    y2: 11793.2,
    gradientTransform: "translate(-14758.97 4853.7) rotate(-147.47)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 396.27,
    y1: 302.46,
    x2: 379.88,
    y2: 302.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 1055.46,
    y1: 1.28,
    x2: 1055.46,
    y2: 480.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#dfe0e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbec0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 198.5,
    y1: 213.83,
    x2: 198.5,
    y2: 520.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#e2e3e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#d9dadb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#c8cacc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbec0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 110.22,
    y1: 560.37,
    x2: 110.22,
    y2: 525.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#747577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#8e8f91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#a2a4a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#b1b2b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#b9bbbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#b8babc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#adaeb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9a9b9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#807f81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#5e5c5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#353233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_11_cop",
    x1: 96.73,
    y1: 619.73,
    x2: 96.73,
    y2: 627.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#e3c8af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 32.38,
    y1: 520.68,
    x2: 32.38,
    y2: 628.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: -10322.88,
    y1: 514.53,
    x2: -10322.88,
    y2: 495.02,
    gradientTransform: "translate(11159.73 1009.1) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed1c24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be1e2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: -10347.91,
    y1: 494.85,
    x2: -10347.91,
    y2: 515.4,
    gradientTransform: "translate(11209.8 1009.1) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f15a29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: -10921.5,
    x2: -10921.5,
    gradientTransform: "translate(12356.98 1009.1) scale(1 -1)",
    xlinkHref: "#linear-gradient-114"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: -10946.53,
    x2: -10946.53,
    gradientTransform: "translate(12407.04 1009.1) scale(1 -1)",
    xlinkHref: "#linear-gradient-115"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 228.59,
    y1: 432.06,
    x2: 228.59,
    y2: 415.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 209.05,
    y1: 420.47,
    x2: 209.05,
    y2: 427.61,
    xlinkHref: "#linear-gradient-113"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 246.63,
    y1: 420.47,
    x2: 246.63,
    y2: 427.61,
    xlinkHref: "#linear-gradient-113"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 227.84,
    y1: 421.43,
    x2: 227.84,
    y2: 426.56,
    xlinkHref: "#linear-gradient-101"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 84.75,
    y1: 500.52,
    x2: 84.75,
    y2: 511.71,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-115"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 7.62,
    y1: 356.93,
    x2: 18.41,
    y2: 388.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#8b8f9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#9296a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9ea1ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#afb2bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c5c7ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#dfe1e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c5c7ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#9a9daa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#8f867e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#938167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 12.87,
    y1: 261.24,
    x2: 12.87,
    y2: 352.51,
    xlinkHref: "#linear-gradient-123"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-163"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "truck2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-161"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-160",
    width: 1696,
    height: 88,
    transform: "translate(-.43 712.2)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M386.51,467.43v-22.48c0-13.6-11.03-24.63-24.64-24.63H60.34v167.59h61.44c14.98,0,29.61,3,42.31,8.66,16.52,7.38,35.51,11.27,54.92,11.27h99.68c8.66,0,17.34-.83,25.76-2.37,7.53,6.08,15.39,10.05,23.09,10.05h150.06v4.66c0,2.43,1.97,4.4,4.4,4.4h8.79v6.65h33.77v-6.65h41.67v6.65h33.78v-6.65h41.67v6.65h33.77v-6.65h8.79c2.43,0,4.4-1.97,4.4-4.4v-7.03l284.03,24.6,1.14-13.13-285.16-24.7v-6.44h49.34v7.77h181.17v-7.77h665.54v-126.04H386.51ZM318.69,588.54h-99.68c-14.98,0-29.61-3-42.31-8.67-5.98-2.67-12.3-4.87-18.83-6.61h158.75c3.36,4.97,7.05,10.06,10.98,14.91-2.96.24-5.94.36-8.91.36ZM342.15,585.99c-3.45-3.87-6.88-8.18-10.22-12.73h50.23c-3.18.84-6.31,1.77-9.35,2.83l-19.12,6.66c-3.72,1.3-7.59,2.36-11.55,3.23ZM517.6,603.02h-150.06c-2.12,0-4.37-.59-6.7-1.63,1.08-.34,2.17-.67,3.23-1.04l19.12-6.67c10.84-3.78,22.95-5.78,35.02-5.78h25.32l-.05.54,74.12,6.42v8.15Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 1651.23,
    y: 555.99,
    width: 4.33,
    height: 32.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1651.01,581.93c-2.21,0-4-1.79-4-4h0c0-2.21,1.79-4,4-4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M1646.49,587.9h7.54c1.52,0,2.75,1.23,2.75,2.75v12.99h-13.04v-12.99c0-1.52,1.23-2.75,2.75-2.75Z",
    transform: "translate(3300.52 1191.55) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M1671.22,550.82c-2.84,2-6.18,3.06-9.65,3.06h-9.98c-.74,0-1.33-.6-1.33-1.33s.6-1.33,1.33-1.33h9.98c2.92,0,5.73-.89,8.12-2.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M1659.09,597.46h-21.75c-.93,0-1.69-.76-1.69-1.69h0c0-.93.76-1.69,1.69-1.69h21.75c.93,0,1.69.76,1.69,1.69h0c0,.93-.76,1.69-1.69,1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M1659.09,594.09h-21.75c-.93,0-1.69-.76-1.69-1.69h0c0-.93.76-1.69,1.69-1.69h21.75c.93,0,1.69.76,1.69,1.69h0c0,.93-.76,1.69-1.69,1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M1643.01,542.25h11.94c2.41,0,4.36,1.95,4.36,4.36v20.57h-20.65v-20.57c0-2.41,1.95-4.36,4.36-4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M1657.1,592.13h-17.76c-1.22,0-2.21-.99-2.21-2.21h0c0-1.22.99-2.21,2.21-2.21h17.76c1.22,0,2.21.99,2.21,2.21h0c0,1.22-.99,2.21-2.21,2.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-145",
    points: "1646.32 586.32 1646.32 567.5 1659.3 567.5 1659.3 564.56 1613.42 564.56 1613.42 589.63 1657.08 589.63 1657.08 586.32 1646.32 586.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1682.59,595.15l-2.82-1.1c-1.53-.6-2.53-2.07-2.53-3.71v-20.64c0-1.91,1.17-3.62,2.95-4.31l2.41-.94c1.16-.45,1.73-1.76,1.28-2.92-.45-1.16-1.76-1.73-2.92-1.28l-15.98,6.24c-2.81,1.1-5.8,1.66-8.82,1.66h-8.87v3.25h10.14c1.25,0,2.26,1.01,2.26,2.26v6.84c0,1.25-1.01,2.26-2.26,2.26h-10.14v3.25h9.38c1.67,0,3.02,1.35,3.02,3.02h0c0,1.22.75,2.31,1.88,2.76l19.39,7.57c.27.1.55.15.82.15.9,0,1.75-.54,2.1-1.43.45-1.16-.12-2.46-1.28-2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M1682.59,595.15l-2.82-1.1c-1.53-.6-2.53-2.07-2.53-3.71v-20.64c0-1.91,1.17-3.62,2.95-4.31l2.41-.94c1.16-.45,1.73-1.76,1.28-2.92-.45-1.16-1.76-1.73-2.92-1.28l-15.98,6.24c-.62.24-1.26.45-1.89.64v25.24l17.87,6.98c.27.1.55.15.82.15.9,0,1.75-.54,2.1-1.43.45-1.16-.12-2.46-1.28-2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M1669.69,548.64c-2.39,1.68-5.2,2.57-8.12,2.57h-2.27v-4.6c0-2.41-1.95-4.36-4.36-4.36h-11.94c-2.41,0-4.36,1.95-4.36,4.36v17.96h-25.23v25.06h23.76c-.01.1-.06.19-.06.29,0,.28.06.55.16.8-.9.03-1.63.76-1.63,1.68s.76,1.69,1.69,1.69c-.93,0-1.69.76-1.69,1.69s.76,1.69,1.69,1.69h6.4v3.43c0,1.52,1.23,2.75,2.75,2.75h7.54c1.52,0,2.75-1.23,2.75-2.75v-3.43h2.31c.93,0,1.69-.76,1.69-1.69s-.76-1.69-1.69-1.69c.93,0,1.69-.76,1.69-1.69s-.73-1.65-1.63-1.68c.1-.25.16-.52.16-.8,0-1.22-.99-2.21-2.21-2.21h-.01v-1.4h-10.76v-18.81h12.98v-13.63h2.27c3.47,0,6.81-1.06,9.65-3.06M1677.44,568.32c.41-1.32,1.4-2.41,2.74-2.93l2.41-.94c1.16-.45,1.73-1.76,1.28-2.92-.45-1.16-1.76-1.73-2.92-1.28l-15.98,6.24c-2.81,1.1-5.8,1.66-8.82,1.66h-8.87v3.25h10.14c1.25,0,2.26,1.01,2.26,2.26v6.84c0,1.25-1.01,2.26-2.26,2.26h-10.14v3.25h9.38c1.67,0,3.02,1.35,3.02,3.02,0,1.22.75,2.31,1.88,2.76l19.39,7.57c.27.1.55.15.82.15.9,0,1.75-.54,2.1-1.43.45-1.16-.12-2.46-1.28-2.92l-2.82-1.1c-.16-.06-.29-.17-.44-.25-1.26-.69-2.09-1.99-2.09-3.46v-20.64c0-.48.07-.94.21-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M1624.7,592.93h0c-1.1,0-2-.89-2-2v-27.67c0-1.1.89-2,2-2h0c1.1,0,2,.89,2,2v27.67c0,1.1-.89,2-2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M262.38,529.61c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM262.38,667.6c-26.01,0-47.09-21.09-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M354.68,623.21v-4.71h-5.8c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.82l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.23c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.8c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.51-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.8c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.23c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.23-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM262.38,667.6c-26.01,0-47.09-21.09-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M262.38,538.14c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM262.38,667.6c-26.01,0-47.09-21.09-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M312.26,628.74c-1.08,1.93-2.53,3.14-4.13,3.14-3.34,0-6.05-5.16-6.05-11.52s2.71-11.52,6.05-11.52c1.57,0,2.99,1.17,4.07,3.04-1.32-7.68-4.36-14.76-8.73-20.84.61,2.14.44,4.02-.7,5.16-2.36,2.36-7.93.63-12.43-3.86-4.5-4.5-6.23-10.06-3.86-12.43,1.12-1.12,2.96-1.29,5.06-.72-6.11-4.32-13.22-7.3-20.92-8.56,1.93,1.08,3.13,2.53,3.13,4.13,0,3.34-5.16,6.05-11.52,6.05s-11.52-2.71-11.52-6.05c0-1.57,1.17-2.99,3.04-4.07-7.68,1.32-14.76,4.36-20.84,8.73,2.14-.61,4.02-.44,5.16.7,2.36,2.36.63,7.93-3.86,12.43-4.5,4.5-10.06,6.23-12.43,3.86-1.12-1.12-1.29-2.96-.72-5.06-4.32,6.11-7.3,13.22-8.56,20.92,1.08-1.93,2.53-3.14,4.13-3.14,3.34,0,6.05,5.16,6.05,11.52s-2.71,11.52-6.05,11.52c-1.57,0-2.99-1.17-4.07-3.04,1.32,7.68,4.36,14.76,8.73,20.84-.61-2.14-.44-4.02.7-5.16,2.37-2.36,7.93-.64,12.43,3.86,4.5,4.5,6.23,10.06,3.86,12.43-1.12,1.12-2.96,1.29-5.06.72,6.11,4.32,13.22,7.3,20.92,8.56-1.93-1.08-3.14-2.53-3.14-4.13,0-3.34,5.16-6.05,11.52-6.05s11.52,2.71,11.52,6.05c0,1.58-1.17,2.99-3.04,4.07,7.68-1.32,14.76-4.36,20.84-8.73-2.14.61-4.02.44-5.16-.7-2.36-2.37-.63-7.93,3.86-12.43,4.5-4.5,10.06-6.23,12.43-3.86,1.12,1.12,1.29,2.96.72,5.06,4.32-6.11,7.3-13.22,8.56-20.92Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-52",
    cx: 262.38,
    cy: 620.5,
    r: 31.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M262.38,569.85c-27.98,0-50.66,22.68-50.66,50.66s22.68,50.66,50.66,50.66,50.66-22.68,50.66-50.66-22.68-50.66-50.66-50.66ZM262.38,668.11c-26.29,0-47.61-21.31-47.61-47.61s21.31-47.61,47.61-47.61,47.61,21.31,47.61,47.61-21.31,47.61-47.61,47.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M262.38,563.02c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM262.38,670.39c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M312.26,628.74c-1.08,1.93-2.53,3.14-4.13,3.14-3.34,0-6.05-5.16-6.05-11.52s2.71-11.52,6.05-11.52c1.57,0,2.99,1.17,4.07,3.04-1.32-7.68-4.36-14.76-8.73-20.84.61,2.14.44,4.02-.7,5.16-2.36,2.36-7.93.63-12.43-3.86-4.5-4.5-6.23-10.06-3.86-12.43,1.12-1.12,2.96-1.29,5.06-.72-6.11-4.32-13.22-7.3-20.92-8.56,1.93,1.08,3.13,2.53,3.13,4.13,0,3.34-5.16,6.05-11.52,6.05s-11.52-2.71-11.52-6.05c0-1.57,1.17-2.99,3.04-4.07-7.68,1.32-14.76,4.36-20.84,8.73,2.14-.61,4.02-.44,5.16.7,2.36,2.36.63,7.93-3.86,12.43-4.5,4.5-10.06,6.23-12.43,3.86-1.12-1.12-1.29-2.96-.72-5.06-4.32,6.11-7.3,13.22-8.56,20.92,1.08-1.93,2.53-3.14,4.13-3.14,3.34,0,6.05,5.16,6.05,11.52s-2.71,11.52-6.05,11.52c-1.57,0-2.99-1.17-4.07-3.04,1.32,7.68,4.36,14.76,8.73,20.84-.61-2.14-.44-4.02.7-5.16,2.37-2.36,7.93-.64,12.43,3.86,4.5,4.5,6.23,10.06,3.86,12.43-1.12,1.12-2.96,1.29-5.06.72,6.11,4.32,13.22,7.3,20.92,8.56-1.93-1.08-3.14-2.53-3.14-4.13,0-3.34,5.16-6.05,11.52-6.05s11.52,2.71,11.52,6.05c0,1.58-1.17,2.99-3.04,4.07,7.68-1.32,14.76-4.36,20.84-8.73-2.14.61-4.02.44-5.16-.7-2.36-2.37-.63-7.93,3.86-12.43,4.5-4.5,10.06-6.23,12.43-3.86,1.12,1.12,1.29,2.96.72,5.06,4.32-6.11,7.3-13.22,8.56-20.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M262.38,568.42c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM262.38,669.46c-27.04,0-48.95-21.92-48.95-48.95s21.92-48.95,48.95-48.95,48.95,21.92,48.95,48.95-21.92,48.95-48.95,48.95Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-54",
    cx: 262.38,
    cy: 620.5,
    r: 18.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "264.85 641.63 260.68 641.63 258.6 645.24 260.68 648.85 264.85 648.85 266.94 645.24 264.85 641.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M264.81,645.24c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "279.06 633.69 276.11 636.64 277.19 640.67 281.22 641.75 284.17 638.8 283.09 634.77 279.06 633.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M281.59,636.27c.8.8.8,2.1,0,2.89s-2.1.8-2.89,0c-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "283.5 618.03 283.5 622.2 287.11 624.29 290.73 622.2 290.73 618.03 287.11 615.94 283.5 618.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M287.11,618.07c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "275.56 603.82 278.51 606.77 282.54 605.69 283.62 601.66 280.67 598.71 276.64 599.79 275.56 603.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M278.15,601.29c.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89-.8.8-2.09.8-2.89,0-.8-.8-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "259.9 599.38 264.08 599.38 266.16 595.77 264.08 592.16 259.9 592.16 257.82 595.77 259.9 599.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M259.94,595.77c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "245.7 607.32 248.65 604.37 247.57 600.34 243.54 599.26 240.59 602.21 241.67 606.24 245.7 607.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M243.17,604.74c-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89-.8.8-2.09.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "241.26 622.98 241.26 618.81 237.65 616.72 234.03 618.81 234.03 622.98 237.65 625.07 241.26 622.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M237.65,622.94c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "249.19 637.19 246.24 634.24 242.21 635.32 241.13 639.35 244.08 642.3 248.11 641.22 249.19 637.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M246.61,639.72c-.8.8-2.09.8-2.89,0s-.8-2.1,0-2.89c.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-63",
    cx: 262.38,
    cy: 620.5,
    r: 13.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M1167.07,594.87l-5.55-10.65c-2.55-4.89-8.58-6.79-13.47-4.24h0c-4.89,2.55-6.79,8.59-4.24,13.48l3.27,6.27h-108.53v-.47h-17.75v.47h-108.53l3.27-6.27c2.55-4.89.65-10.92-4.24-13.48h0c-4.89-2.55-10.93-.65-13.48,4.24l-5.55,10.64c-2.55,4.89-.65,10.92,4.24,13.47h0c4.41,2.3,9.72.96,12.6-2.91h25.15v2.85h9.89v2.85h15.67v2.85h17.31v2.85h22.27v2.85h21.4v1.86h17.75v-1.86h21.4v-2.85h22.27v-2.85h17.32v-2.85h15.66v-2.85h9.89v-2.85h25.16c2.88,3.87,8.19,5.21,12.6,2.91h0c4.89-2.55,6.79-8.59,4.24-13.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-133",
    cx: 1029.92,
    cy: 620.5,
    r: 39.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M1403.53,594.87l-5.55-10.65c-2.55-4.89-8.58-6.79-13.47-4.24h0c-4.89,2.55-6.79,8.59-4.24,13.48l3.27,6.27h-108.53v-.47h-17.75v.47h-108.53l3.27-6.27c2.55-4.89.65-10.92-4.24-13.48h0c-4.89-2.55-10.93-.65-13.48,4.24l-5.55,10.64c-2.55,4.89-.65,10.92,4.24,13.47h0c4.41,2.3,9.72.96,12.6-2.91h25.15v2.85h9.89v2.85h15.67v2.85h17.31v2.85h22.27v2.85h21.4v1.86h17.75v-1.86h21.4v-2.85h22.27v-2.85h17.32v-2.85h15.66v-2.85h9.89v-2.85h25.16c2.88,3.87,8.19,5.21,12.6,2.91h0c4.89-2.55,6.79-8.59,4.24-13.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-133",
    cx: 1266.38,
    cy: 620.5,
    r: 39.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 1115.45,
    y: 546.32,
    width: 65.43,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 1107.55,
    y: 552.12,
    width: 81.24,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 1099.64,
    y: 557.92,
    width: 97.06,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 1091.73,
    y: 563.71,
    width: 112.87,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 1083.83,
    y: 569.51,
    width: 128.68,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 1075.92,
    y: 575.31,
    width: 144.5,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 1068.01,
    y: 581.11,
    width: 160.31,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 1060.11,
    y: 586.91,
    width: 176.12,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 1052.2,
    y: 592.7,
    width: 191.94,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 1044.29,
    y: 598.5,
    width: 207.75,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 1036.39,
    y: 604.3,
    width: 223.57,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 1028.48,
    y: 610.1,
    width: 239.38,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 1124.64,
    y: 545.07,
    width: 7.19,
    height: 72.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 1164.51,
    y: 545.07,
    width: 7.19,
    height: 72.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M1129.34,609.89l7.54,34.13c.42,1.9,1.44,3.14,2.58,3.14h17.42c1.14,0,2.16-1.25,2.58-3.14l7.54-34.13c.72-3.26-.62-6.8-2.58-6.8h-32.49c-1.96,0-3.3,3.54-2.58,6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M1129.46,629.33c-4.44.38-8.02,3.25-9.6,7.11l-100.9,8.57.88,10.35,100.9-8.57c2.21,3.53,6.23,5.77,10.66,5.39,6.31-.54,10.99-6.09,10.46-12.4-.54-6.31-6.09-10.99-12.4-10.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M1166.88,629.33c4.44.38,8.02,3.25,9.6,7.11l100.9,8.57-.88,10.35-100.9-8.57c-2.21,3.53-6.23,5.77-10.66,5.39-6.31-.54-10.99-6.09-10.46-12.4.54-6.31,6.09-10.99,12.4-10.46Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-133",
    cx: 1029.92,
    cy: 620.5,
    r: 39.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M1029.67,529.61c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM1029.67,667.6c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1121.97,623.21v-4.71h-5.81c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.82l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.23c-.86-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.8c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.5-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.8c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.23c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.24-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM1029.67,667.6c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1029.67,538.14c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM1029.67,667.6c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1029.67,563.02c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM1029.67,670.39c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M1029.67,568.42c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM1029.67,668.6c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M1029.64,570.02c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM996.87,587.95c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM988.83,630.94c-2.98,0-5.4-4.6-5.4-10.28s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28ZM1008.14,656.75c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09ZM1029.51,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM1029.77,666.75c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1051.14,584.32c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM1062.41,653.12c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.09-3.45,2.11,2.11.57,7.07-3.45,11.08ZM1070.45,630.68c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M1079.68,613.93c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.27,5.4-10.27s5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28c0,1.21-.13,2.36-.33,3.44,1.75-3.11,3.13-6.44,4.16-9.91ZM1004.51,595.59c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45s.57,7.07-3.45,11.08ZM1029.51,585.13c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1065.67,598.85c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M994.47,599.69c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM1029.51,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1029.64,570.02c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM996.87,587.95c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM988.83,630.94c-2.98,0-5.4-4.6-5.4-10.28s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28ZM1008.14,656.75c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09ZM1029.51,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM1029.77,666.75c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1051.14,584.32c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM1062.41,653.12c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.09-3.45,2.11,2.11.57,7.07-3.45,11.08ZM1070.45,630.68c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "1032.14 641.63 1027.97 641.63 1025.89 645.24 1027.97 648.85 1032.14 648.85 1034.23 645.24 1032.14 641.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M1032.1,645.24c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "1046.35 633.69 1043.4 636.64 1044.48 640.67 1048.51 641.75 1051.46 638.8 1050.38 634.77 1046.35 633.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M1048.88,636.27c.8.8.8,2.1,0,2.89s-2.1.8-2.89,0c-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "1050.79 618.03 1050.79 622.2 1054.4 624.29 1058.02 622.2 1058.02 618.03 1054.4 615.94 1050.79 618.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M1054.4,618.07c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "1042.85 603.82 1045.8 606.77 1049.83 605.69 1050.91 601.66 1047.96 598.71 1043.93 599.79 1042.85 603.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M1045.44,601.29c.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89s-2.09.8-2.89,0c-.8-.8-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "1027.19 599.38 1031.37 599.38 1033.45 595.77 1031.37 592.16 1027.19 592.16 1025.11 595.77 1027.19 599.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M1027.23,595.77c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "1012.99 607.32 1015.94 604.37 1014.86 600.34 1010.83 599.26 1007.88 602.21 1008.96 606.24 1012.99 607.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M1010.46,604.74c-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "1008.55 622.98 1008.55 618.81 1004.94 616.72 1001.32 618.81 1001.32 622.98 1004.94 625.07 1008.55 622.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M1004.94,622.94c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "1016.48 637.19 1013.53 634.24 1009.5 635.32 1008.42 639.35 1011.37 642.3 1015.4 641.22 1016.48 637.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M1013.9,639.72c-.8.8-2.09.8-2.89,0-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0s.8,2.1,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-44",
    cx: 1029.67,
    cy: 620.5,
    r: 18.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-42",
    cx: 1029.67,
    cy: 620.5,
    r: 13.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-133",
    cx: 1266.61,
    cy: 620.5,
    r: 39.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M1266.37,529.61c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM1266.37,667.6c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1358.66,623.21v-4.71h-5.81c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.82l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.23c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.8c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.51-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.8c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.23c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.24-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM1266.37,667.6c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1266.37,538.14c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM1266.37,667.6c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M1266.37,563.02c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM1266.37,670.39c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M1266.37,568.42c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM1266.37,668.6c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M1266.33,570.02c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM1233.57,587.95c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM1225.52,630.94c-2.98,0-5.4-4.6-5.4-10.28s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28ZM1244.84,656.75c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09ZM1266.2,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.28-2.42-10.28-5.4,4.6-5.4,10.28-5.4ZM1266.46,666.75c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1287.83,584.32c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM1299.1,653.12c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM1307.14,630.68c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M1316.37,613.93c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.27,5.4-10.27s5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28c0,1.21-.13,2.36-.33,3.44,1.75-3.11,3.13-6.44,4.16-9.91ZM1241.2,595.59c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM1266.2,585.13c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1302.37,598.85c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M1231.16,599.69c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM1266.2,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1266.33,570.02c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM1233.57,587.95c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM1225.52,630.94c-2.98,0-5.4-4.6-5.4-10.28s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28ZM1244.84,656.75c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09ZM1266.2,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.28-2.42-10.28-5.4,4.6-5.4,10.28-5.4ZM1266.46,666.75c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1287.83,584.32c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM1299.1,653.12c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM1307.14,630.68c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "1268.84 641.63 1264.67 641.63 1262.58 645.24 1264.67 648.85 1268.84 648.85 1270.93 645.24 1268.84 641.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M1268.8,645.24c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "1283.05 633.69 1280.1 636.64 1281.18 640.67 1285.21 641.75 1288.16 638.8 1287.08 634.77 1283.05 633.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M1285.58,636.27c.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0s-.8-2.1,0-2.89,2.09-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "1287.49 618.03 1287.49 622.2 1291.1 624.29 1294.71 622.2 1294.71 618.03 1291.1 615.94 1287.49 618.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M1291.1,618.07c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "1279.55 603.82 1282.5 606.77 1286.53 605.69 1287.61 601.66 1284.66 598.71 1280.63 599.79 1279.55 603.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M1282.13,601.29c.8-.8,2.1-.8,2.89,0s.8,2.1,0,2.89c-.8.8-2.1.8-2.89,0s-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "1263.89 599.38 1268.06 599.38 1270.15 595.77 1268.06 592.16 1263.89 592.16 1261.81 595.77 1263.89 599.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M1263.93,595.77c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "1249.68 607.32 1252.63 604.37 1251.55 600.34 1247.52 599.26 1244.57 602.21 1245.65 606.24 1249.68 607.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M1247.15,604.74c-.8-.8-.8-2.1,0-2.89s2.1-.8,2.89,0c.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "1245.25 622.98 1245.25 618.81 1241.63 616.72 1238.02 618.81 1238.02 622.98 1241.63 625.07 1245.25 622.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M1241.63,622.94c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "1253.18 637.19 1250.23 634.24 1246.2 635.32 1245.12 639.35 1248.07 642.3 1252.1 641.22 1253.18 637.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M1250.6,639.72c-.8.8-2.1.8-2.89,0-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-49",
    cx: 1266.37,
    cy: 620.5,
    r: 18.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-45",
    cx: 1266.37,
    cy: 620.5,
    r: 13.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M1410.53,682.15c-6.08-2.73-23.11-5.04-24.13-26.15-.48-9.85-.67-34.51-.81-46h-3.32v46.37c0,11.72,1.6,14.72,6.78,23.52,3.47,5.88,10.51,9.59,17.74,6.9l3.55-1.32c1.69-.63,1.82-2.59.19-3.32Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-37",
    cx: 1184.08,
    cy: 528.21,
    r: 6.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1355.7,528.21c0,3.8-3.08,6.88-6.88,6.88s-6.88-3.08-6.88-6.88,3.08-6.88,6.88-6.88,6.88,3.08,6.88,6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1381.9,620.5h-11.99c0-57.04-46.41-103.45-103.45-103.45s-103.46,46.41-103.46,103.45h-11.99c0-63.66,51.79-115.44,115.45-115.44s115.45,51.79,115.45,115.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M1375.66,620.5h-4.8c0-57.57-46.84-104.41-104.41-104.41s-104.41,46.84-104.41,104.41h-4.8c0-60.22,48.99-109.21,109.21-109.21s109.21,48.99,109.21,109.21Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-37",
    cx: 947.3,
    cy: 528.21,
    r: 6.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-37",
    cx: 1112.04,
    cy: 528.21,
    r: 6.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1145.12,620.5h-11.99c0-57.04-46.41-103.45-103.45-103.45s-103.46,46.41-103.46,103.45h-11.99c0-63.66,51.79-115.44,115.45-115.44s115.45,51.79,115.45,115.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M1138.88,620.5h-4.8c0-57.57-46.84-104.41-104.41-104.41s-104.41,46.84-104.41,104.41h-4.8c0-60.22,48.99-109.21,109.21-109.21s109.21,48.99,109.21,109.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M1408.91,576.09l-6.29,4.39v48.83l6.29,4.39c2.35,1.64,5.28,2.54,8.3,2.54h155.42c3.01,0,5.94-.89,8.3-2.54l6.29-4.39h0v-48.83h0l-6.29-4.39c-2.35-1.64-5.28-2.54-8.3-2.54h-155.42c-3.02,0-5.94.89-8.3,2.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 1470.5,
    y: 512.59,
    width: 48.83,
    height: 184.59,
    transform: "translate(890.02 2099.81) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 1583.63,
    y: 582.75,
    width: 5.86,
    height: 1.31,
    transform: "translate(2169.97 -1003.15) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 1581.05,
    y: 582.55,
    width: 5.86,
    height: 1.71,
    transform: "translate(2167.39 -1000.57) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 1577.87,
    y: 582.43,
    width: 5.86,
    height: 1.96,
    transform: "translate(2164.21 -997.39) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 1574.04,
    y: 582.22,
    width: 5.86,
    height: 2.38,
    transform: "translate(2160.38 -993.57) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 1569.55,
    y: 582.01,
    width: 5.86,
    height: 2.79,
    transform: "translate(2155.88 -989.07) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 1564.5,
    y: 581.88,
    width: 5.86,
    height: 3.05,
    transform: "translate(2150.84 -984.03) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 1558.92,
    y: 581.68,
    width: 5.86,
    height: 3.46,
    transform: "translate(2145.26 -978.44) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 1552.87,
    y: 581.57,
    width: 5.86,
    height: 3.67,
    transform: "translate(2139.21 -972.39) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 1546.2,
    y: 581.47,
    width: 5.86,
    height: 3.88,
    transform: "translate(2132.54 -965.72) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 1539.27,
    y: 581.31,
    width: 5.86,
    height: 4.19,
    transform: "translate(2125.61 -958.79) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 1531.84,
    y: 581.24,
    width: 5.86,
    height: 4.34,
    transform: "translate(2118.17 -951.36) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 1524.18,
    y: 581.09,
    width: 5.86,
    height: 4.63,
    transform: "translate(2110.52 -943.71) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 1516.17,
    y: 581.09,
    width: 5.86,
    height: 4.63,
    transform: "translate(2102.51 -935.69) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 1508.05,
    y: 580.99,
    width: 5.86,
    height: 4.83,
    transform: "translate(2094.39 -927.57) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 1499.83,
    y: 580.99,
    width: 5.86,
    height: 4.83,
    transform: "translate(2086.17 -919.35) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 1400.34,
    y: 582.75,
    width: 5.86,
    height: 1.31,
    transform: "translate(819.87 1986.68) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 1402.92,
    y: 582.55,
    width: 5.86,
    height: 1.71,
    transform: "translate(822.44 1989.26) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 1406.1,
    y: 582.43,
    width: 5.86,
    height: 1.96,
    transform: "translate(825.62 1992.44) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 1409.93,
    y: 582.22,
    width: 5.86,
    height: 2.38,
    transform: "translate(829.45 1996.27) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 1414.43,
    y: 582.01,
    width: 5.86,
    height: 2.79,
    transform: "translate(833.95 2000.76) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 1419.47,
    y: 581.88,
    width: 5.86,
    height: 3.05,
    transform: "translate(838.99 2005.81) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 1425.05,
    y: 581.68,
    width: 5.86,
    height: 3.46,
    transform: "translate(844.57 2011.39) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 1431.1,
    y: 581.57,
    width: 5.86,
    height: 3.67,
    transform: "translate(850.62 2017.44) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 1437.77,
    y: 581.47,
    width: 5.86,
    height: 3.88,
    transform: "translate(857.29 2024.11) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 1444.7,
    y: 581.31,
    width: 5.86,
    height: 4.19,
    transform: "translate(864.22 2031.04) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 1452.14,
    y: 581.24,
    width: 5.86,
    height: 4.34,
    transform: "translate(871.66 2038.47) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 1459.79,
    y: 581.09,
    width: 5.86,
    height: 4.63,
    transform: "translate(879.31 2046.13) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 1467.8,
    y: 581.09,
    width: 5.86,
    height: 4.63,
    transform: "translate(887.33 2054.14) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 1475.92,
    y: 580.99,
    width: 5.86,
    height: 4.83,
    transform: "translate(895.44 2062.26) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 1484.14,
    y: 580.99,
    width: 5.86,
    height: 4.83,
    transform: "translate(903.67 2070.48) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 1491.99,
    y: 581.03,
    width: 5.86,
    height: 4.76,
    transform: "translate(911.51 2078.32) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 1583.63,
    y: 625.72,
    width: 5.86,
    height: 1.31,
    transform: "translate(2212.93 -960.18) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 1581.05,
    y: 625.52,
    width: 5.86,
    height: 1.71,
    transform: "translate(2210.36 -957.61) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 1577.87,
    y: 625.39,
    width: 5.86,
    height: 1.96,
    transform: "translate(2207.18 -954.42) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 1574.04,
    y: 625.19,
    width: 5.86,
    height: 2.38,
    transform: "translate(2203.35 -950.6) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 1569.55,
    y: 624.98,
    width: 5.86,
    height: 2.79,
    transform: "translate(2198.85 -946.1) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 1564.5,
    y: 624.85,
    width: 5.86,
    height: 3.05,
    transform: "translate(2193.81 -941.06) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 1558.92,
    y: 624.64,
    width: 5.86,
    height: 3.46,
    transform: "translate(2188.23 -935.47) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 1552.87,
    y: 624.54,
    width: 5.86,
    height: 3.67,
    transform: "translate(2182.18 -929.42) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 1546.2,
    y: 624.44,
    width: 5.86,
    height: 3.88,
    transform: "translate(2175.5 -922.75) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 1539.27,
    y: 624.28,
    width: 5.86,
    height: 4.19,
    transform: "translate(2168.58 -915.82) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1531.84,
    y: 624.2,
    width: 5.86,
    height: 4.34,
    transform: "translate(2161.14 -908.39) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 1524.18,
    y: 624.06,
    width: 5.86,
    height: 4.63,
    transform: "translate(2153.49 -900.74) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 1516.17,
    y: 624.06,
    width: 5.86,
    height: 4.63,
    transform: "translate(2145.47 -892.72) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 1508.05,
    y: 623.96,
    width: 5.86,
    height: 4.83,
    transform: "translate(2137.36 -884.6) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 1499.83,
    y: 623.96,
    width: 5.86,
    height: 4.83,
    transform: "translate(2129.13 -876.38) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 1400.34,
    y: 625.72,
    width: 5.86,
    height: 1.31,
    transform: "translate(776.9 2029.65) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 1402.92,
    y: 625.52,
    width: 5.86,
    height: 1.71,
    transform: "translate(779.47 2032.23) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 1406.1,
    y: 625.39,
    width: 5.86,
    height: 1.96,
    transform: "translate(782.65 2035.41) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 1409.93,
    y: 625.19,
    width: 5.86,
    height: 2.38,
    transform: "translate(786.48 2039.23) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 1414.43,
    y: 624.98,
    width: 5.86,
    height: 2.79,
    transform: "translate(790.98 2043.73) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 1419.47,
    y: 624.85,
    width: 5.86,
    height: 3.05,
    transform: "translate(796.02 2048.77) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 1425.05,
    y: 624.64,
    width: 5.86,
    height: 3.46,
    transform: "translate(801.61 2054.36) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 1431.1,
    y: 624.54,
    width: 5.86,
    height: 3.67,
    transform: "translate(807.66 2060.41) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 1437.77,
    y: 624.44,
    width: 5.86,
    height: 3.88,
    transform: "translate(814.33 2067.08) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1444.7,
    y: 624.28,
    width: 5.86,
    height: 4.19,
    transform: "translate(821.26 2074.01) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 1452.14,
    y: 624.2,
    width: 5.86,
    height: 4.34,
    transform: "translate(828.69 2081.44) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 1459.79,
    y: 624.06,
    width: 5.86,
    height: 4.63,
    transform: "translate(836.34 2089.09) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 1467.8,
    y: 624.06,
    width: 5.86,
    height: 4.63,
    transform: "translate(844.36 2097.11) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: 1475.92,
    y: 623.96,
    width: 5.86,
    height: 4.83,
    transform: "translate(852.48 2105.23) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 1484.14,
    y: 623.96,
    width: 5.86,
    height: 4.83,
    transform: "translate(860.7 2113.45) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 1491.99,
    y: 624,
    width: 5.86,
    height: 4.76,
    transform: "translate(868.54 2121.29) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1475.33,
    y: 512.59,
    width: 39.17,
    height: 184.59,
    transform: "translate(890.02 2099.81) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M1420.11,616.96l-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.15.11-.24.25-.24.39v1.42l2.35-1.7c.39-.28,1.09-.28,1.48,0l1.72,1.24h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.86-2.06,2.37,1.7-.12.07,1.17.69.18.13h.02s.02,0,.02,0l3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38h0l1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.72,2.2,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38h0s1.39.82,1.39.82l1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.72,2.2.04-.02.03.02.29-.21,1.03-.61-.1-.06,2.38-1.71,2.46,1.77h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.36,1.7v-1.42c0-.14-.08-.28-.24-.39l-1.73-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.82,1.31c-.36.26-1.01.28-1.41.04l-2.3-1.36-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-3.72,2.2c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-3.72-2.2-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.28,1.35c-.4.24-1.05.22-1.41-.04l-1.81-1.3-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M1420.11,607.5l-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.15.11-.24.25-.24.39v1.42l2.35-1.7c.39-.28,1.09-.28,1.48,0l1.72,1.24h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.86-2.06,2.37,1.7-.12.07,1.17.69.18.13h.02s.02,0,.02,0l3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38h0l1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.72,2.2,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38h0s1.39.82,1.39.82l1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.72,2.2.04-.02.03.02.29-.21,1.03-.61-.1-.06,2.38-1.71,2.46,1.77h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.36,1.7v-1.42c0-.14-.08-.28-.24-.39l-1.73-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.82,1.31c-.36.26-1.01.28-1.41.04l-2.3-1.36-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-3.72,2.2c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-3.72-2.2-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.28,1.35c-.4.24-1.05.22-1.41-.04l-1.81-1.3-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M1420.11,598.05l-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.15.11-.24.25-.24.39v1.42l2.35-1.7c.39-.28,1.09-.28,1.48,0l1.72,1.24h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.86-2.06,2.37,1.7-.12.07,1.17.69.18.13h.02s.02,0,.02,0l3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38h0l1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.72,2.2,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38h0s1.39.82,1.39.82l1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.72,2.2.04-.02.03.02.29-.21,1.03-.61-.1-.06,2.38-1.71,2.46,1.77h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.36,1.7v-1.42c0-.14-.08-.28-.24-.39l-1.73-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.82,1.31c-.36.26-1.01.28-1.41.04l-2.3-1.36-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-3.72,2.2c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-3.72-2.2-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.28,1.35c-.4.24-1.05.22-1.41-.04l-1.81-1.3-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M1420.11,588.59l-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.15.11-.24.25-.24.39v1.42l2.35-1.7c.39-.28,1.09-.28,1.48,0l1.72,1.24h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.86-2.06,2.37,1.7-.12.07,1.17.69.18.13h.02s.02,0,.02,0l3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38h0l1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.72,2.2,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38h0s1.39.82,1.39.82l1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.72,2.2.04-.02.03.02.29-.21,1.03-.61-.1-.06,2.38-1.71,2.46,1.77h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.36,1.7v-1.42c0-.14-.08-.28-.24-.39l-1.73-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.82,1.31c-.36.26-1.01.28-1.41.04l-2.3-1.36-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-3.72,2.2c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-3.72-2.2-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.28,1.35c-.4.24-1.05.22-1.41-.04l-1.81-1.3-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 1402.62,
    y: 573.56,
    width: 184.59,
    height: 37.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M386.51,477.54h0c-2.95,0-5.34-2.39-5.34-5.34v-178.18c0-2.95,2.39-5.34,5.34-5.34h0c2.95,0,5.34,2.39,5.34,5.34v178.18c0,2.95-2.39,5.34-5.34,5.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 563.95,
    y: 512.34,
    width: 9.63,
    height: 47.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 586.37,
    y: 512.34,
    width: 9.63,
    height: 47.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 608.79,
    y: 512.34,
    width: 9.63,
    height: 47.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 631.22,
    y: 512.34,
    width: 9.63,
    height: 47.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 653.64,
    y: 512.34,
    width: 9.63,
    height: 47.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 586.37,
    y: 512.34,
    width: 9.63,
    height: 47.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 608.79,
    y: 512.34,
    width: 9.63,
    height: 47.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 631.22,
    y: 512.34,
    width: 9.63,
    height: 47.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 653.64,
    y: 512.34,
    width: 9.63,
    height: 47.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 676.06,
    y: 512.34,
    width: 9.63,
    height: 47.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 555.69,
    y: 516.36,
    width: 138.25,
    height: 61.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 551.35,
    y: 525.89,
    width: 11.28,
    height: 55.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 687.01,
    y: 525.89,
    width: 11.28,
    height: 55.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 1619.06,
    y: 600.36,
    width: 22.94,
    height: 17.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M1607,491.73h36.11v47.75h-36.11c-5.94,0-10.76-4.82-10.76-10.76v-26.23c0-5.94,4.82-10.76,10.76-10.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1642.18,517.42h0c1.45,0,2.62,1.17,2.62,2.62v13.55c0,1.45-1.17,2.62-2.62,2.62h0c-3.16,0-5.72-2.56-5.72-5.71v-7.36c0-3.16,2.56-5.71,5.72-5.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 1642.82,
    y: 518.82,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1643.28,519.14h.14c.19,0,.35.16.35.35v3.85c0,.19-.16.35-.35.35h-.14c-.19,0-.35-.16-.35-.35v-3.85c0-.19.16-.35.35-.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 1641.11,
    y: 518.82,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1641.22,
    y: 519.14,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 1639.4,
    y: 518.82,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1639.51,
    y: 519.14,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1642.18,495h0c1.45,0,2.62,1.17,2.62,2.62v13.55c0,1.45-1.17,2.62-2.62,2.62h0c-3.16,0-5.72-2.56-5.72-5.72v-7.36c0-3.16,2.56-5.72,5.72-5.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 1642.82,
    y: 496.4,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 1642.93,
    y: 496.72,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 1641.11,
    y: 496.4,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 1641.22,
    y: 496.72,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 1639.4,
    y: 496.4,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 1639.51,
    y: 496.72,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M249.69,312.66c1.74-2.14,2.66-4.94,2.3-7.88l-2.46-19.75c-.71-5.71-5.96-9.8-11.67-9.09l-.34.04c-5.71.71-9.8,5.96-9.09,11.67l2.46,19.75c.37,2.96,1.98,5.47,4.22,7.12-4.18,2.64-7.24,7.01-8,12.25l-8.48,58.55c-1.38,9.51,5.27,18.41,14.78,19.79,9.51,1.38,18.41-5.27,19.79-14.78l8.48-58.55c1.24-8.54-4.01-16.58-11.99-19.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M86.08,352.79c-.2,1.92,1.18,3.66,3.04,4.16l23.56,6.41-2.76,10.14c-.38,1.39-1.81,2.21-3.2,1.83h0c-.95-.26-1.92.3-2.18,1.25l-14.33,52.66,21.4,5.82,14.33-52.66c.26-.95-.3-1.92-1.25-2.18h0c-1.39-.38-2.21-1.81-1.83-3.2l2.76-10.14,23.56,6.41c1.86.51,3.93-.3,4.73-2.05,1.02-2.24-.23-4.75-2.5-5.36l-60.46-16.45c-2.27-.62-4.61.92-4.87,3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M123.71,256.39h107.92c3.94,0,8.59,4.65,8.59,10.39v92.69c0,9.45-6.37,17.7-15.5,20.11l-127.56,33.59c-11.55,3.04-22.71-5.98-22.24-17.91,1.57-39.32,10.85-78.66,31.34-128.14,2.82-6.81,8.28-10.73,17.45-10.73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 273,
    y: 256.39,
    width: 63.55,
    height: 113.32,
    rx: 11.09,
    ry: 11.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M273,341.73v16.89c0,6.13,4.97,11.09,11.09,11.09h41.37c6.13,0,11.09-4.97,11.09-11.09v-16.89h-63.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M136.22,353.37l-5.79,8.81c-3.08,4.7-8.33,7.53-13.95,7.53h-39.42c-1.09,8.59-1.8,17.08-2.14,25.56-.47,11.93,10.7,20.94,22.24,17.9l127.56-33.59c9.13-2.4,15.5-10.66,15.5-20.11v-17.75h-82.45c-8.69,0-16.79,4.37-21.56,11.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M367.39,523.4v108.78c0,15.09,1.6,18.96,6.78,30.3,3.47,7.57,10.51,12.35,17.74,8.88l3.55-1.7c1.69-.81,1.82-3.33.19-4.28-6.07-3.52-23.11-6.5-24.13-33.68-1.62-43.08.07-113.48-4.13-108.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M431.14,522.33h-24.76v-33.44c0-4.01-3.25-7.26-7.26-7.26s-7.26,3.25-7.26,7.26v70.4c0,4.26,3.45,7.71,7.71,7.71h31.58c4.26,0,7.71-3.45,7.71-7.71v-29.25c0-4.26-3.45-7.71-7.71-7.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M415.86,552.21h24.76v33.44c0,4.01,3.25,7.26,7.26,7.26s7.26-3.25,7.26-7.26v-70.4c0-4.26-3.45-7.71-7.71-7.71h-31.58c-4.26,0-7.71,3.45-7.71,7.71v29.25c0,4.26,3.45,7.71,7.71,7.71Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 431.65,
    cy: 535.43,
    r: 34.46,
    transform: "translate(-194.69 251.33) rotate(-26.73)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 431.65,
    cy: 535.43,
    r: 27.78,
    transform: "translate(-199.18 261.45) rotate(-27.65)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 431.65,
    cy: 535.43,
    r: 21.32,
    transform: "translate(-150.29 901.99) rotate(-83.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 431.65,
    cy: 535.43,
    r: 17.19,
    transform: "translate(-220.21 316.13) rotate(-32.53)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M397.65,282.02c0-4.55-3.69-8.23-8.23-8.23s-8.23,3.69-8.23,8.23v49.12h16.47v-49.12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1613.42,
    y: 468.56,
    width: 11.28,
    height: 167.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 443.89,
    width: 1223.14,
    height: 474.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 450.79,
    y: 6,
    width: 1209.34,
    height: 462.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 450.79,
    y: 6,
    width: 1209.34,
    height: 462.56
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-158",
    points: "455.12 8.79 1660.13 8.79 1660.13 6 450.79 6 450.79 468.56 455.12 468.56 455.12 8.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M356.34,242.6c-3-8.99-13.79-25.78-34.17-28.78-20.38-3-206.85,2.4-218.24,7.79-11.39,5.4-74.34,176.26-74.34,206.04,0,38.17-2.8,68.16,2.8,89.94h145.21l5.17-4.8c15.78-14.64,36.51-22.78,58.03-22.78h116.29v-20.18c0-3.87,3.14-7,7-7,2.24,0,4.05-1.81,4.05-4.05v-86.69c0-27.98-8.79-120.51-11.79-129.5ZM240.22,359.48c0,9.45-6.37,17.7-15.5,20.11l-127.56,33.59c-11.55,3.04-22.71-5.98-22.24-17.91,1.57-39.32,10.85-78.66,31.34-128.14,2.82-6.81,8.28-10.73,17.45-10.73h107.92c3.94,0,8.59,4.65,8.59,10.39v92.69ZM336.55,358.62c0,6.13-4.97,11.09-11.09,11.09h-41.37c-6.13,0-11.09-4.97-11.09-11.09v-91.13c0-6.13,4.97-11.09,11.09-11.09h41.37c6.13,0,11.09,4.97,11.09,11.09v91.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M335.36,431.18c-124.03,0-234.59,18.08-306.44,46.31.03,2.13.08,4.2.15,6.24,71.85-28.19,182.35-46.25,306.3-46.25,11.04,0,21.96.15,32.77.43v-6.3c-10.81-.28-21.73-.43-32.77-.43Z"
  }), /*#__PURE__*/React.createElement("image", {
    width: 340,
    height: 81,
    transform: "translate(28.57 437.2)",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "166.74 517.6 35.08 517.6 35.08 590.44 67.95 590.44 67.95 629.52 75.74 629.52 75.74 590.44 117.71 590.44 117.71 629.52 125.51 629.52 125.51 590.44 137.16 590.44 166.74 517.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "134.22 565.17 67.95 565.17 67.95 525 152.49 525 134.22 565.17"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 66,
    y: 622.94,
    width: 61.45,
    height: 6.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M122,204.92h219.58v24.37H97.83v-.21c0-13.34,10.83-24.16,24.16-24.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M358.5,202.96V46.77s-216.57,125.18-239.8,148.15c-23.23,22.97-20.79,32.45-20.79,32.45l260.59-24.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M358.5,213.3v-72.11s-216.57,51.79-239.8,66.84c-23.23,15.04-20.79,21.26-20.79,21.26l260.59-15.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M126.68,560.57h-46.44c-4.11,0-7.45-3.34-7.45-7.45v-28.12h74.86l-14.19,31.21c-1.21,2.66-3.86,4.37-6.78,4.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 66,
    y: 619.65,
    width: 61.45,
    height: 6.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M63.55,629.52H29.38c-15.56,0-28.18-39.53-28.18-54.76v-38.48c0-8.95,7.49-16.28,16.64-16.28h45.72v109.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 882.74,
    y: 507.07,
    width: 4.7,
    height: 111.66,
    rx: 2.28,
    ry: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 500.69,
    y: 507.07,
    width: 4.7,
    height: 111.66,
    rx: 2.28,
    ry: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 480.25,
    y: 563.56,
    width: 427.61,
    height: 18.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 480.25,
    y: 565.68,
    width: 427.61,
    height: 13.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 480.25,
    y: 568.15,
    width: 427.61,
    height: 8.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 480.25,
    y: 605.13,
    width: 427.61,
    height: 18.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 480.25,
    y: 607.24,
    width: 427.61,
    height: 13.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 480.25,
    y: 609.72,
    width: 427.61,
    height: 8.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 1576.02,
    y: 507.07,
    width: 4.7,
    height: 111.66,
    rx: 2.28,
    ry: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 1409.15,
    y: 507.07,
    width: 4.7,
    height: 111.66,
    rx: 2.28,
    ry: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 1388.7,
    y: 563.56,
    width: 212.43,
    height: 18.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 1388.7,
    y: 565.68,
    width: 212.43,
    height: 13.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 1388.7,
    y: 568.15,
    width: 212.43,
    height: 8.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 1388.7,
    y: 605.13,
    width: 212.43,
    height: 18.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 1388.7,
    y: 607.24,
    width: 212.43,
    height: 13.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 1388.7,
    y: 609.72,
    width: 212.43,
    height: 8.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M356.34,242.61c-1.84-5.52-6.63-13.96-14.75-20.36v-7.91l16.92-1.04V46.77s-216.57,125.18-239.8,148.15c-23.23,22.97-20.79,32.45-20.79,32.45h.01c-.02.26-.03.53-.04.8-.04.3-.05.53-.04.71,0,.07,0,.13,0,.2v.21h.45c-19.11,34.37-68.71,171.94-68.71,198.37,0,38.17-2.8,68.16,2.8,89.95h145.21l5.17-4.8c15.78-14.64,36.51-22.78,58.03-22.78h116.29v-20.18c0-3.87,3.14-7.01,7-7.01,2.23,0,4.05-1.81,4.05-4.05v-86.68c0-27.98-8.79-120.51-11.79-129.5ZM240.22,359.48c0,9.45-6.37,17.7-15.5,20.11l-127.56,33.58c-11.55,3.04-22.71-5.98-22.24-17.91,1.57-39.32,10.85-78.66,31.34-128.14,2.82-6.81,8.28-10.73,17.45-10.73h107.92c3.94,0,8.59,4.65,8.59,10.39v92.69ZM336.55,358.62c0,6.13-4.97,11.09-11.09,11.09h-41.37c-6.13,0-11.09-4.97-11.09-11.09v-91.13c0-6.13,4.97-11.09,11.09-11.09h41.37c6.13,0,11.09,4.97,11.09,11.09v91.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 822.69,
    y: 491.73,
    width: 53.37,
    height: 25.65,
    rx: 3.6,
    ry: 3.6,
    transform: "translate(1698.75 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 825.03,
    y: 494.44,
    width: 23.65,
    height: 20.22,
    rx: 3.58,
    ry: 3.58,
    transform: "translate(1673.72 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 825.95,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1654.67 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 826.63,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1655.1 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 829.75,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1662.29 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 830.44,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1662.72 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 833.56,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1669.91 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 834.24,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1670.34 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 837.37,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1677.52 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 838.05,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1677.96 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 841.18,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1685.14 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 841.86,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1685.58 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 844.99,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1692.76 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 845.67,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1693.2 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 850.06,
    y: 494.44,
    width: 23.65,
    height: 20.22,
    rx: 3.58,
    ry: 3.58,
    transform: "translate(1723.78 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 850.98,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1704.73 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 851.66,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1705.16 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 854.79,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1712.35 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 855.47,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1712.78 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 858.59,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1719.97 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 859.28,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1720.4 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 862.4,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1727.59 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 863.08,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1728.02 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 866.21,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1735.2 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 866.89,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1735.64 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 870.02,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1742.82 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 870.7,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1743.26 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M1424.91,491.73h46.17c1.99,0,3.6,1.61,3.6,3.6v18.44c0,1.99-1.61,3.6-3.6,3.6h-46.17c-1.99,0-3.6-1.61-3.6-3.6v-18.44c0-1.99,1.61-3.6,3.6-3.6Z",
    transform: "translate(2895.99 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 1423.65,
    y: 494.44,
    width: 23.65,
    height: 20.22,
    rx: 3.58,
    ry: 3.58,
    transform: "translate(2870.96 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 1424.57,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2851.91 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 1425.25,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2852.34 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 1428.38,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2859.53 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 1429.06,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2859.96 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 1432.19,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2867.15 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 1432.87,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2867.58 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 1435.99,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2874.77 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 1436.68,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2875.2 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 1439.8,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2882.39 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 1440.48,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2882.82 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 1443.61,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2890 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 1444.29,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2890.44 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 1448.68,
    y: 494.44,
    width: 23.65,
    height: 20.22,
    rx: 3.58,
    ry: 3.58,
    transform: "translate(2921.02 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 1449.6,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2901.97 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1450.28,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2902.41 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 1453.41,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2909.59 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1454.09,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2910.02 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 1457.22,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2917.21 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1457.9,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2917.64 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 1461.02,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2924.83 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1461.71,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2925.26 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 1464.83,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2932.45 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1465.52,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2932.88 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 1468.64,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2940.07 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1469.32,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2940.5 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 209.05,
    y: 415.69,
    width: 39.07,
    height: 16.37,
    rx: 8.19,
    ry: 8.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 213.75,
    y: 420.31,
    width: 28.17,
    height: 7.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M214.65,427.45h-7.62c-1.97,0-3.57-1.6-3.57-3.57h0c0-1.97,1.6-3.57,3.57-3.57h7.62v7.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M241.03,420.31h7.62c1.97,0,3.57,1.6,3.57,3.57h0c0,1.97-1.6,3.57-3.57,3.57h-7.62v-7.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 215.17,
    y: 421.31,
    width: 25.34,
    height: 5.14,
    rx: 1.11,
    ry: 1.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 74.39,
    y: 499.36,
    width: 20.71,
    height: 12.88,
    rx: 1.64,
    ry: 1.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M77.85,500.3h13.79c1.29,0,2.33,1.04,2.33,2.33v6.34c0,1.29-1.04,2.33-2.33,2.33h-13.79c-1.29,0-2.33-1.04-2.33-2.33v-6.34c0-1.29,1.04-2.33,2.33-2.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 91.09,
    y: 501.35,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 91.28,
    y: 501.52,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 88.12,
    y: 501.35,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.31,
    y: 501.52,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 85.15,
    y: 501.35,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 85.34,
    y: 501.52,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 82.18,
    y: 501.35,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 82.37,
    y: 501.52,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 79.21,
    y: 501.35,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 79.4,
    y: 501.52,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 76.23,
    y: 501.35,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 76.43,
    y: 501.52,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M16.73,389.67c-.4.12-.83.17-1.27.14-1.82-.12-3.08-1.54-2.83-3.19,2.09-13.66-6.85-24.06-6.94-24.16-1.09-1.25-.8-3.13.67-4.21,1.46-1.08,3.54-.94,4.64.31.44.49,10.68,12.3,8.21,28.48-.19,1.25-1.2,2.26-2.47,2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M7.69,359.52c-.43-.49-1.03-.76-1.67-.9-1.12,1.1-1.32,2.71-.33,3.84.09.1,3.87,7.76,6.94,24.16.28,1.48.82,2.75,2.37,3.07.47-.46.8-1.05.9-1.7,2.47-16.18-7.77-27.99-8.2-28.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M128.21,249.6h-4.65c-.96,0-1.78.58-2.17,1.4H23.95c-13.21,0-23.95,10.75-23.95,23.95v96.79c0,9.82,5.89,18.54,15,22.21l65.88,26.56c.03,1.3,1.08,2.35,2.39,2.35h4.65c1.32,0,2.4-1.07,2.4-2.4s-1.07-2.4-2.4-2.4h-4.65c-.44,0-.82.15-1.18.35l-66.2-26.69c-5.23-2.11-9.27-6.08-11.51-10.97l7.92-3.19c.63-.25.94-.97.68-1.61-.25-.63-.97-.94-1.61-.68l-7.89,3.18c-.69-2.13-1.09-4.39-1.09-6.72v-62.87h12.78c.66,0,1.2-.54,1.2-1.2s-.54-1.2-1.2-1.2H2.4v-31.52c0-11.89,9.67-21.55,21.55-21.55h97.71c.44.59,1.1,1,1.9,1h4.65c1.32,0,2.4-1.07,2.4-2.4s-1.07-2.4-2.4-2.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-141",
    cx: 15.79,
    cy: 306.76,
    rx: 6.1,
    ry: 41.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M16.55,264.22h.98v85.07h-.98c-4.61,0-8.34-3.74-8.34-8.34v-68.38c0-4.61,3.74-8.34,8.34-8.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M8.21,272.49h.1c1.8,0,3.25,1.46,3.25,3.25v62.02c0,1.8-1.46,3.25-3.25,3.25h-.1v-68.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M381.8,531.84c0-25.52-20.69-46.21-46.21-46.21h-104.53c-30.03,0-57.31,17.48-69.85,44.76l-27.85,60.56h7.1c8.07,0,15.4-4.7,18.77-12.03l18.77-40.81c9.53-20.72,30.25-34,53.05-34h104.54c15.31,0,27.73,12.41,27.73,27.73v45.06c0,7.76,6.29,14.06,14.06,14.06h4.43v-59.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M357.3,245.9H117.75c-8.54,0-16.2,5.07-19.52,12.93-10.67,25.25-35.48,90.47-35.48,150.45v108.32h2.4v-108.32c0-59.55,24.68-124.4,35.29-149.52,2.94-6.96,9.73-11.46,17.31-11.46h135.21c2.15.72,3.72,2.73,3.72,5.12v217.13c0,9.58-7.79,17.37-17.37,17.37h-5.71v1.8h5.71c10.57,0,19.17-8.6,19.17-19.17v-217.13c0-2-.82-3.81-2.14-5.12h100.96c.66,0,1.2-.54,1.2-1.2s-.54-1.2-1.2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M386.51,529.59c0-26.49-21.47-47.96-47.96-47.96h-108.5c-31.17,0-59.48,18.14-72.5,46.46l-28.9,62.86h7.37c8.38,0,15.98-4.88,19.48-12.49l19.48-42.36c9.89-21.51,31.39-35.29,55.07-35.29h108.5c15.89,0,28.78,12.88,28.78,28.78v46.76c0,8.06,6.53,14.59,14.59,14.59h4.6v-61.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M28.95,470.04h0c-.25,18.74.1,34.62,3.43,47.56h8.89v-35.24c0-6.8-5.52-12.32-12.32-12.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M42.47,482.36c0-7.45-6.06-13.52-13.52-13.52-.66,0-1.2.54-1.2,1.2s.54,1.2,1.2,1.2c6.13,0,11.12,4.99,11.12,11.12v35.24h2.4v-35.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M39.77,430.68c0-21.13,28.84-110.02,51.01-167.03,1.36-3.5-1.23-7.26-4.99-7.26h-.22c-22.55,52.9-55.99,149.56-55.99,171.26,0,2.71-.02,5.37-.04,8.01h5.3c2.72,0,4.94-2.2,4.94-4.93v-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M92.59,414.97c-4.24,0-8.36-1.43-11.78-4.18-4.74-3.81-7.33-9.49-7.08-15.57,1.61-40.29,11.3-79.94,31.43-128.55,3.15-7.61,9.39-11.47,18.56-11.47h107.92c4.53,0,9.79,5.06,9.79,11.59v92.69c0,9.98-6.74,18.73-16.39,21.27l-127.56,33.58c-1.62.43-3.26.64-4.88.64ZM123.71,257.59c-8.21,0-13.56,3.27-16.34,9.99-20.01,48.34-29.65,87.73-31.25,127.73-.21,5.32,2.04,10.28,6.19,13.61,4.13,3.31,9.43,4.44,14.55,3.09l127.56-33.58c8.6-2.26,14.61-10.06,14.61-18.95v-92.69c0-4.95-4.07-9.19-7.39-9.19h-107.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M325.46,370.91h-41.37c-6.78,0-12.29-5.51-12.29-12.29v-91.13c0-6.78,5.51-12.29,12.29-12.29h41.37c6.78,0,12.29,5.51,12.29,12.29v91.13c0,6.78-5.51,12.29-12.29,12.29ZM284.09,257.59c-5.45,0-9.89,4.44-9.89,9.89v91.13c0,5.45,4.44,9.89,9.89,9.89h41.37c5.45,0,9.89-4.44,9.89-9.89v-91.13c0-5.45-4.44-9.89-9.89-9.89h-41.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M34.83,436.86h-5.3c-.66,0-1.2-.54-1.2-1.2s.54-1.2,1.2-1.2h5.3c2.06,0,3.74-1.67,3.74-3.73,0-22.09,30.26-113.96,51.09-167.51.5-1.29.34-2.68-.44-3.82-.79-1.15-2.04-1.81-3.43-1.81-.66,0-1.31-.54-1.31-1.2s.42-1.2,1.09-1.2c2.39,0,4.41,1.07,5.63,2.85,1.22,1.78,1.48,4.04.69,6.05-23.55,60.54-50.92,146.5-50.92,166.59,0,3.43-2.75,6.18-6.14,6.18Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3AxTandem);
export default __webpack_public_path__ + "static/media/3-Ax Tandem.c03422d26dbe7e5672f806f5596e7406.svg";
export { ForwardRef as ReactComponent };